export default "__VITE_ASSET__C5idj5oF__"